<template>
    <div>
      <TimeMonthTable></TimeMonthTable>
    </div>
</template>

<script>
import moment from 'moment'
import TimeMonthTable from '@/components/month/TimeMonthTable.vue'

export default {
  name: 'MonthRegistrations',
  components: {
    TimeMonthTable
  },
   data: function() {
       return {
       }
   },
   beforeCreate: function() {
    if(!this.$route.params.time || !this.$route.params.time === undefined ||  !this.$route.params.time === 'NaN') {
      this.$router.replace({
          params: { time: moment().format('M') }
      });
    }
  }
}
</script>
